var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M14.1668 5.83301H10.8335V7.49967H14.1668C15.5418 7.49967 16.6668 8.62467 16.6668 9.99967C16.6668 11.3747 15.5418 12.4997 14.1668 12.4997H10.8335V14.1663H14.1668C16.4668 14.1663 18.3335 12.2997 18.3335 9.99967C18.3335 7.69967 16.4668 5.83301 14.1668 5.83301Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M9.1665 12.4997H5.83317C4.45817 12.4997 3.33317 11.3747 3.33317 9.99967C3.33317 8.62467 4.45817 7.49967 5.83317 7.49967H9.1665V5.83301H5.83317C3.53317 5.83301 1.6665 7.69967 1.6665 9.99967C1.6665 12.2997 3.53317 14.1663 5.83317 14.1663H9.1665V12.4997Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "M6.6665 9.16699H13.3332V10.8337H6.6665V9.16699Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.0cfe471e54219a1c3318d559d626af46.svg";
export { ForwardRef as ReactComponent };